// {{WORKTREE_ROOT}}/picosponsorconsole/app/components/shell/machineTranslationSlot.tsx
// PLAN2 WP10 — the place of the machine-translation note (R-175). The root renders it above the page while the UI
// language's locale file says reviewed:false. PLAN2 WP33 D33-9 fills it: the one-line note (MachineTranslationNote).
import type { ComponentType } from "react";
import type { HostKind } from "~/config/hosts";
import { MachineTranslationNote } from "./MachineTranslationNote";
export interface MachineTranslationNoteProps { hostKind: HostKind }
export const MachineTranslationNoteSlot: ComponentType<MachineTranslationNoteProps> | null = MachineTranslationNote;
